import createCrud from '../../crud';

import { SET_FILTERS, SET_FILTER, UNSET_FILTER_USER_ID, SET_DISPLAYED_USERSTORIES } from 'vx/mutations'

export default createCrud({
    resource: 'stories',
    parent: 'yodizproject/sprints',
    state : {
      filters: {
        status: null,
        tags: [],
        users: []
      },
      displayedStoryIds: []
    },
    getters: {
      getByEpicId: (state) => (id) => {
        return state.list.filter(story => {
          return story.epic_id === id;
        })
      },
      getByEpicIdAndFilters: (state, getters) => (id) => {
        return getters.getByFilters().filter(story => {
          return story.epic_id === id
        })
      },
      getByFilters: (state) => () => {
        let filteredTagsIds = state.filters.tags.map(tag => { return tag.id})

        return state.list.filter(story => {

          //Only show userstorys that match the filter status selcted
          if (state.filters.status !== null && story.status !== state.filters.status) return false


          //Only show userstorys that match the filter status users
          if (state.filters.users.length && !state.filters.users.map((user) => { return user.id}).includes(story.creator_id)) return false

          //Only show userstorys that match the filter tags
          //Has to be the last filter as will return true
          if (state.filters.tags.length) {
            return story.tags.some(tag => filteredTagsIds.indexOf(tag.id) > -1)
          }

          return true
        })
      },
      getByUserIds: (state) => (userIds) => {
        return state.list.filter(story => {
          return userIds.includes(story.creator_id);
        })
      }
    },
    mutations: {
      /**
       * Set the list state
       * @param {*} state
       * @param {*} filters
       */
      [SET_FILTERS] (state, filters) {
        state.filters = filters
      },

      /**
       * Set the list state
       * @param {*} state
       * @param {*} filters
       */
      [UNSET_FILTER_USER_ID] (state, id) {
        state.filters.users.splice(state.filters.users.findIndex(user => user.id === id), 1)
      },

      /**
       * Set the list state
       * @param {*} state
       * @param {*} filters
       */
      [SET_DISPLAYED_USERSTORIES] (state, userstoryIds) {
        state.displayedStoryIds = userstoryIds
      },
    },
    actions : {

      /**
       * Set the filters.
       */
      setFilters ({ commit }, filters) {
        commit(SET_FILTERS, filters)
        return true
      },

      /**
       * Remove user filter
       * @param {*} param0
       * @param {*} id
       */
      unsetUserFromFilterById ({ commit }, id) {
        commit(UNSET_FILTER_USER_ID, id)
        return true
      },


      /**
       * Set the displayed userstories.
       */
      setDisplayedUserstoryIds ({ commit }, userstoryIds) {
        commit(SET_DISPLAYED_USERSTORIES, userstoryIds)
        return true
      },

      /**
       * Update only when we don't have newer changed
       * @param {} param0
       * @param {*} item
       */
      updateIfLatestVersion({ commit, getters }, item) {

        let stateItem = getters.getById(item.id);

        if (stateItem !== undefined && item.version > stateItem.version) {
          commit(UPDATE_LIST_ITEM, [item])
        }
      }
    }
  });
